<script setup lang="ts">
import { computed } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { erpIntegrationApi } from '@/api/erp-integration';
import { useResponsiveTable } from '@/composables/useResponsiveTable';

// Products and jobs the connection's maps don't cover yet. Kuido never
// guesses them: Kuido's team maps them in the connection's settings.

const { tableProps } = useResponsiveTable({ desktopItemsPerPage: 25 });

const { data, isPending } = useQuery({
  queryKey: ['erpIntegration', 'unmapped'],
  queryFn: erpIntegrationApi.unmapped,
});

const products = computed(() => data.value?.products ?? []);
const jobs = computed(() => data.value?.jobs ?? []);

const productHeaders = [
  { title: 'Producto en Odoo', key: 'productName' },
  { title: 'Líneas', key: 'lines' },
  { title: 'Presupuestos', key: 'salesOrders' },
];
const jobHeaders = [
  { title: 'Cargo en Odoo', key: 'jobName' },
  { title: 'Empleados', key: 'employees' },
];
</script>
<template>
  <div class="pa-4">
    <p class="mb-4 text-body-2 text-medium-emphasis">
      Kuido no adivina qué es un producto o un cargo nuevo de Odoo. Pide al equipo de Kuido
      mapearlos (especialidad y duración de cada producto; especialidad de cada cargo); la
      próxima sincronización los incorpora.
    </p>
    <h2 class="text-h6 mb-2">
      Productos sin mapear
    </h2>
    <v-data-table
      v-bind="tableProps"
      :header-props="{ class: 'font-weight-bold' }"
      :headers="productHeaders"
      :items="products"
      :loading="isPending"
      loading-text="Cargando los productos..."
      no-data-text="No hay productos por mapear"
      density="compact"
    >
      <template #[`item.productName`]="{ item }">
        <div>{{ item.productName ?? '—' }}</div>
        <div class="text-caption text-medium-emphasis">
          ID Odoo {{ item.productId }}
        </div>
      </template>
    </v-data-table>
    <h2 class="text-h6 mt-6 mb-2">
      Cargos sin mapear
    </h2>
    <v-data-table
      v-bind="tableProps"
      :header-props="{ class: 'font-weight-bold' }"
      :headers="jobHeaders"
      :items="jobs"
      :loading="isPending"
      loading-text="Cargando los cargos..."
      no-data-text="No hay cargos por mapear"
      density="compact"
    >
      <template #[`item.jobName`]="{ item }">
        <div>{{ item.jobName ?? 'Cargo sin nombre' }}</div>
        <div
          v-if="item.jobId"
          class="text-caption text-medium-emphasis"
        >
          ID Odoo {{ item.jobId }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>
